/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMandsThankyouData } from './mands-thankyou.data';
import { IMandsThankyouProps } from './mands-thankyou.props.autogenerated';

/**
 *
 * MandsThankyou component
 * @extends {React.PureComponent<IMandsThankyouProps<IMandsThankyouData>>}
 */
export default class MandsThankyou extends React.PureComponent<IMandsThankyouProps<IMandsThankyouData>> {
    public render(): JSX.Element {
        const {
            config: { headingText, redirectionLink, paragraphText }
        } = this.props;

        return (
            <div className='mands-thankyou'>
                {headingText && <h2 className='mands-thankyou-heading'>{headingText}</h2>}
                {paragraphText && <p>{paragraphText}</p>}
                {redirectionLink && redirectionLink.linkText && (
                    <a href={redirectionLink.linkUrl.destinationUrl}>{redirectionLink.linkText}</a>
                )}
            </div>
        );
    }
}
